/* istanbul ignore file */
export const ExclamationMarkIcon = () => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="40" height="40" rx="20" fill="#FEE4E2" />
            <path
                d="M2.88326 0.777344C3.93757 0.777344 4.78694 1.65384 4.76815 2.72242L4.52782 16.3939C4.51183 17.303 3.78024 18.0315 2.88326 18.0315C1.98628 18.0315 1.25469 17.303 1.23871 16.3939L0.998368 2.72242C0.979583 1.65384 1.82896 0.777344 2.88326 0.777344ZM2.88909 25.2218C2.24357 25.2218 1.69137 24.9932 1.2325 24.5359C0.773627 24.0707 0.548081 23.511 0.555859 22.8566C0.548081 22.2101 0.773627 21.6582 1.2325 21.2009C1.69137 20.7358 2.24357 20.5032 2.88909 20.5032C3.51907 20.5032 4.06349 20.7358 4.52236 21.2009C4.98123 21.6582 5.21455 22.2101 5.22233 22.8566C5.21455 23.2902 5.10178 23.6883 4.88401 24.051C4.67402 24.4058 4.39403 24.6896 4.04405 24.9025C3.69406 25.1154 3.30908 25.2218 2.88909 25.2218Z"
                fill="#B42318"
                style={{ transform: 'translate(17px, 5px)' }}
            />
        </svg>
    );
};
